
import React, { Component } from 'react';
import { Card, Table, Tooltip, Icon, Switch,Button } from 'antd';
import { connect } from 'react-redux';
import { bulbShow, bulbColor, resStyle } from '../../actions/viewerActions';
import { pdbDFscoreUrl } from '../../UrlManager';
import { bulbDefaultColor } from './PocketBulb';
import ColorPicker from 'rc-color-picker';

class FeaturePanel extends Component {
  downloadFile = () => {
    // Set the file URL to the specific file you want to download
    const { searchid } = this.props;
    const fileUrl = pdbDFscoreUrl(searchid);

    // Create an invisible anchor element to trigger the download
    const link = document.createElement('a');
    link.href = fileUrl;

    // Extract the file name from the URL
    const fileName = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);

    // Set the extracted file name as the download attribute
    link.download = fileName;

    // Trigger a click event to start the download
    link.click();
  };


  handleMoleculeInteraction = (record) => {
    const { viewer } = this.props;
    const chain = record.ch;
    const positionGroups = record.pos.split(';').map(group => group.trim());
  
    // Set the entire structure to grey
    viewer.setStyle({}, {cartoon: {color: "grey",opacity: 0.9}});
  
    positionGroups.forEach(group => {
      if (group.includes('-')) {
        // Handle ranges, e.g., '10-18'
        const [start, end] = group.split('-').map(num => parseInt(num.trim()));
        viewer.setStyle({chain: chain}, {cartoon: {color: 'orange',opacity: 0.85}});
        for (let i = start; i <= end; i++) {
          viewer.setStyle({chain: chain, resi: i}, {sphere: {color: 'cyan',opacity: 0.85}});
        }
      } else if (group.includes(',')) {
        // Handle comma-separated lists, e.g., '1,4,8'
        viewer.setStyle({chain: chain}, {cartoon: {color: 'orange',opacity: 0.85}});
        const positions = group.split(',').map(num => parseInt(num.trim()));
        positions.forEach(position => {
          // viewer.setStyle({chain: chain}, {cartoon: {color: 'orange',opacity: 0.85}});
          viewer.setStyle({chain: chain, resi: position}, {sphere: {color: 'cyan',opacity: 0.85}});
        });
      } else {
        // Handle single positions
        const position = parseInt(group);
        viewer.setStyle({chain: chain}, {cartoon: {color: 'orange',opacity: 0.85}});
        viewer.setStyle({chain: chain, resi: position}, {sphere: {color: 'cyan',opacity: 0.85}});
      }
    });
  
    // Optionally zoom to the first position of the first group if needed
    // if (positionGroups.length > 0) {
    //   const firstGroup = positionGroups[0];
    //   const firstPosition = firstGroup.split(/[-,]/)[0];
    //   viewer.zoomTo({chain: chain, resi: parseInt(firstPosition)});
    //   setTimeout(() => viewer.zoom(0.1), 100);
    // }
  
    viewer.render();
  };
 

  handleShowPocketSwitch = (checked, record) => {
    if (record.ft.startsWith('Functional pocket: ')) {
        const pocketIds = record.ft.replace('Functional pocket: ', '').split(',').map(id => parseInt(id.trim()) - 1);
        pocketIds.forEach(pocketId => {
            bulbShow(pocketId, checked);
        });
    } else {
        console.log('The record does not pertain to a functional pocket and will be skipped.');
    }
  };

  extractPocketInfo = (checked, record) => {
    // Check if the ft includes a colon, indicating a detailed pocket description
    const colonIndex = record.ft.indexOf(':');
    if (colonIndex !== -1) {
        // Extract the pocket numbers after 'Functional pocket:'
        const pocketInfo = record.ft.substring(colonIndex + 1).trim();
        // Split pocket numbers by comma, trim them, and handle each one
        const pockets = pocketInfo.split(',').map(s => s.trim());
        
        // Use forEach on the array of pockets
        pockets.forEach(pocketId => {
            bulbShow(pocketId-1, checked);
        });
    } else {
        console.log('The record does not pertain to a pocket and will be skipped.');
    }
    // This function does not need to return anything as it's used for side effects
};

  getColumns = (isShortSearchId) => {
    let columns = isShortSearchId ? [
      {
        title: 'Show Pockets',
        key: 'showPocket',
        align: 'center',
        render: (text, record) => (
          <Switch 
            size="small"
            onChange={(show) => this.extractPocketInfo(show, record)}
          />
        )
      },
      { title: 'Annotation', dataIndex: 'ft', key: 'ft', align: 'center' },
      { title: 'Chain', dataIndex: 'ch', key: 'ch', align: 'center' },
      { title: 'Position(s)', dataIndex: 'pos', key: 'pos', align: 'center' },
      { title: 'Description', dataIndex: 'dscr', key: 'dscr', align: 'center' },
      {
        title: 'Reference',
        dataIndex: 'spid',
        key: 'spid',
        align: 'center',
        render: spid => <a target="_blank" rel="noopener noreferrer" href={`http://www.uniprot.org/uniprot/${spid}`}>{spid}</a>
      },
    ] : [
      {
        title: 'Show Pockets',
        key: 'showPocket',
        align: 'center',
        render: (text, record) => (
          <Switch 
            size="small"
            onChange={(show) => this.handleShowPocketSwitch(show, record)}
          />
        )
      },
      { title: 'Predicted Functional Region', dataIndex: 'ft', key: 'ft', align: 'center' },
      { title: 'Chain', dataIndex: 'ch', key: 'ch', align: 'center' },
      { title: 'Position(s)', dataIndex: 'pos', key: 'pos', align: 'center' },
      { title: 'Predicted Function', dataIndex: 'dscr', key: 'dscr', align: 'center' },
      {
        title: 'Reference',
        dataIndex: 'spid',
        key: 'spid',
        align: 'center',
        render: spid => <a target="_blank" rel="noopener noreferrer" href={`https://amigo.geneontology.org/amigo/term/${spid}`}>{spid}</a>
      },
      
    ];

    return columns;
  };

  // getDataSource = () => {
  //   return this.props.featInfo && this.props.featInfo.fulfilled ? this.props.featInfo.value : [];
  // };
  getDataSource = () => {
    const { featInfo } = this.props;
    if (featInfo && featInfo.fulfilled) {
        // Clone the data array to avoid directly mutating props
        let data = [...featInfo.value];

        // Sort data: 'Functional pocket: xxx' rows first, sorted by the smallest number in 'xxx'
        data.sort((a, b) => {
            const pocketPattern = /^Functional pocket: (\d+)/;
            const matchA = a.ft.match(pocketPattern);
            const matchB = b.ft.match(pocketPattern);
            if (matchA && matchB) {
                return parseInt(matchA[1]) - parseInt(matchB[1]); // Sort by first number extracted
            } else if (matchA) {
                return -1; // Any functional pocket should come before non-matching items
            } else if (matchB) {
                return 1; // Any functional pocket should come after non-matching items
            }
            return 0; // No change in order for items without functional pockets
        });

        return data;
    }
    return [];
};

  getFeatTitle = (isShortSearchId) => {
    // const featTip = isShortSearchId ? 'Annotations from UniProtKB/Swiss-Prot database.' : 'Predicted function data from DeepFRI.';
    const featTip = (
              <p className='tip'>
                {isShortSearchId ? (
                  <div>
                    Annotations from{' '}
                    <a target='_blank' rel='noopener noreferrer' href='https://www.uniprot.org/'>
                      UniProtKB/Swiss-Prot
                    </a>{' '}
                    database.
                  </div>
                ) : (
                  // Modify this part for long search IDs
                  <div>
                    Residues located in predicted functional pocket(s), their sequence positions, and GO terms/EC numbers are listed, using{' '}
                    <a target='_blank' rel='noopener noreferrer' href='https://github.com/flatironinstitute/DeepFRI'>
                      DeepFRI
                    </a>{' '}
                    method.
                     {/* and reference can be found in{' '}
                    <a target='_blank' rel='noopener noreferrer' href='https://geneontology.org/'>
                      The Gene Ontology Resource
                    </a>{' '}
                    database. */}
                  </div>
                )}
              </p>
            );
    return (
      <span>
        {isShortSearchId ? 'Annotation (PDB) ' : 'Predicted Function (AF2) '}
        <Tooltip title={featTip} placement='right'>
          <Icon type='question-circle' />
        </Tooltip>
      </span>
    );
  };

  // render() {
  //   const isShortSearchId = this.props.searchid.length <= 5;
  //   const columns = this.getColumns(isShortSearchId);
  //   const dataSource = this.getDataSource();
  //   const featTitle = this.getFeatTitle(isShortSearchId);

  //   return (
  //     <Card title={featTitle}>
  //       <Table
  //         columns={columns}
  //         dataSource={dataSource}
  //         onRow={record => ({
  //           onClick: () => this.handleMoleculeInteraction(record),
  //           onMouseEnter: () => { document.body.style.cursor = 'pointer'; },
  //           onMouseLeave: () => { document.body.style.cursor = 'default'; },
  //         })}
  //       />
  //     </Card>
  //   );
  // }
  render() {
    const isShortSearchId = this.props.searchid.length <= 5; // Determine if it's the AF2 panel based on `searchid`
    const columns = this.getColumns(isShortSearchId);
    const dataSource = this.getDataSource();
    const featTitle = this.getFeatTitle(isShortSearchId);

    return (
      <Card title={featTitle}>
        {/* Conditionally render the download button for the AF2 panel */}
        {!isShortSearchId && (
          <Button type="primary" onClick={this.downloadFile} style={{ marginBottom: '10px' }}>
            Download DeepFRI Score
          </Button>
        )}
        <Table
          columns={columns}
          dataSource={dataSource}
          onRow={record => ({
            onClick: () => this.handleMoleculeInteraction(record),
            onMouseEnter: () => { document.body.style.cursor = 'pointer'; },
            onMouseLeave: () => { document.body.style.cursor = 'default'; },
          })}
        />
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  searchid: state.router.location.search.slice(1),
  featInfo: state.repository.feat,
  viewer: state.viewer.viewer,
});


export default connect(mapStateToProps)(FeaturePanel);



// WEBPACK FOOTER //
// ./src/components/searchpage/FeaturePanel.js